import config from '@/config'
import { requests } from './BaseService'

export type ClientPortalMetaResponse = {
  portalUrl?: unknown
  url?: unknown
  [key: string]: unknown
}

/** Prefer portalUrl, then url — never invent a domain from subdomain pieces. */
export function extractClientPortalUrl(
  meta: ClientPortalMetaResponse | null | undefined
): string | undefined {
  if (!meta || typeof meta !== 'object') {
    return undefined
  }

  for (const key of ['portalUrl', 'url'] as const) {
    const value = meta[key]
    if (typeof value === 'string') {
      const trimmed = value.trim()
      if (trimmed) {
        return trimmed
      }
    }
  }

  return undefined
}

export const ClientPortalService = {
  getPortalMeta: (locationId: string) =>
    requests().get<ClientPortalMetaResponse>(
      `${config.restApiUrl}/clientclub/portal-settings/${locationId}/meta`
    ),
}
